import { logger } from '../utils/logger';
import React from 'react';

/**
 * Development watermark is temporarily disabled because it interferes with other UI overlays.
 * Keep a stub so the component can be imported without linter warnings.
 */
const DevWatermark: React.FC = () => {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return null;
};

export default DevWatermark;

